const styles = {
  showRecentNotificationButton: {
    position: 'absolute',
    right: 100,
    top: 75,
    zIndex: 1001
  },
  noResults: { transform: 'translate(-50%, -50%)', position: 'absolute', top: '50%', left: '50%' },
  statusTag: {
    ml: 'auto',
    mr: 2,
    fontSize: 12,
    py: 0.25,
    px: 0.5,
    color: 'white.main',
    borderRadius: 2,
    fontWeight: 600
  }
};

export default styles;
